module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"comments:no-comments":"Комментарии отсутствуют"},"en":{"comments:no-comments":"No comments"}}')
  delete Component.options._Ctor
}
